import React from 'react';
import PropTypes from 'prop-types';
import ContactPersonItem from './ContactPersonItem';
import { Translate } from '../../../Share/components';
import './style.scss';

function ContactPersonList({ data, onAddEditcontactPerson }) {
  return (
    <>
      <div className="w-100 d-flex justify-content-end">
        <button
          className="tv_dashboard__add-button"
          type="button"
          onClick={onAddEditcontactPerson}
        >
          <i className="fa fa-plus" />
          {' '}
          {Translate({
            content: 'manageUsers.addContactPerson',
          })}
        </button>
      </div>
      <div className="row tv-reportquality__list-item-parent tv-reportquality__list-item-header d-none d-md-flex mb-0 custom">
        <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl">
          <div className="tv-reportquality__item-text">Namn</div>
        </div>
        <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl ">
          <div className="tv-reportquality__item-text">E-post</div>
        </div>
        <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl ">
          <div className="tv-reportquality__item-text">Kontaktnummer</div>
        </div>
        <div className="col-12 col-xs-6  col-sm-6 col-md col-lg col-xl ">
          <div className="tv-reportquality__item-text" />
        </div>
      </div>
      <div className="tv-contactperson__list-wrapper">
        {data && data.map((item, index) => (
          <ContactPersonItem
            key={item.ContactPersonIdentifier || index}
            item={item}
            onEdit={onAddEditcontactPerson}
          />
        ))}
      </div>
    </>
  );
}

ContactPersonList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    ContactPersonIdentifier: PropTypes.string,
    FirstName: PropTypes.string,
    LastName: PropTypes.string,
    Email: PropTypes.string,
    PhoneNumberDirect: PropTypes.string,
    PhoneNumberMobile: PropTypes.string,
  })).isRequired,
  onAddEditcontactPerson: PropTypes.func.isRequired,
};

export default ContactPersonList;
